/**
 * Simple SPA Router for Filmssavn
 */

class Router {
  constructor() {
    this.routes = {};
    this.currentRoute = null;
    this.params = {};

    // Handle browser back/forward
    window.addEventListener('popstate', () => this.handleRoute());

    // Handle link clicks
    document.addEventListener('click', (e) => {
      const link = e.target.closest('[data-link]');
      if (link) {
        e.preventDefault();
        this.navigate(link.getAttribute('href'));
      }
    });
  }

  /**
   * Register a route
   */
  addRoute(path, handler) {
    this.routes[path] = handler;
  }

  /**
   * Navigate to a path
   */
  navigate(path) {
    const targetUrl = new URL(path, window.location.origin);
    const currentUrl = new URL(window.location.href);

    if (
      targetUrl.pathname === currentUrl.pathname &&
      targetUrl.search === currentUrl.search &&
      targetUrl.hash === currentUrl.hash
    ) {
      return;
    }

    window.history.pushState({}, '', targetUrl.pathname + targetUrl.search + targetUrl.hash);
    this.handleRoute();
  }

  /**
   * Handle current route
   */
  async handleRoute() {
    const path = window.location.pathname;

    console.log('🔍 Router handling path:', path);
    console.log('🔍 Available routes:', Object.keys(this.routes));

    // Scroll to top when route changes
    window.scrollTo({ top: 0, behavior: 'smooth' });

    // Try exact match first
    if (this.routes[path]) {
      console.log('✅ Exact match found:', path);
      this.currentRoute = path;
      this.params = {};
      await this.routes[path](this.params);
      return;
    }

    // Try pattern matching for dynamic routes
    for (const [pattern, handler] of Object.entries(this.routes)) {
      const params = this.matchRoute(pattern, path);
      if (params) {
        console.log('✅ Pattern match found:', pattern);
        this.currentRoute = pattern;
        this.params = params;
        await handler(params);
        return;
      }
    }

    console.log('❌ No route match, redirecting to home');
    // 404 - replace current history entry instead of pushing new one
    window.history.replaceState({}, '', '/');
    this.handleRoute();
  }

  /**
   * Match a route pattern against a path
   */
  matchRoute(pattern, path) {
    const patternParts = pattern.split('/');
    const pathParts = path.split('/');

    if (patternParts.length !== pathParts.length) {
      return null;
    }

    const params = {};

    for (let i = 0; i < patternParts.length; i++) {
      const patternPart = patternParts[i];
      const pathPart = pathParts[i];

      if (patternPart.startsWith(':')) {
        // Dynamic parameter
        const paramName = patternPart.slice(1);
        params[paramName] = pathPart;
      } else if (patternPart !== pathPart) {
        // No match
        return null;
      }
    }

    return params;
  }

  /**
   * Initialize router
   */
  init() {
    this.handleRoute();
  }
}

export const router = new Router();
